<script setup lang="ts">
import { RouterView } from 'vue-router';
</script>

<template>
  <div class="app-shell flex min-h-dvh flex-col bg-parchment-50">
    <RouterView />
  </div>
</template>
